import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';

export const numericBadge = style([
  {
    ...typography['labelSm'],
    borderRadius: borderRadius.r16,
    padding: `${space.s4}px ${space.s10}px`,
    color: themeVars.badge.foreground.primary,
    backgroundColor: themeVars.badge.primary.background.idle,
    outline: `1px solid ${themeVars.badge.border.tertiary}`,
    outlineOffset: '-1px',

    selectors: {
      '&[data-important]': {
        outline: 'none',
        backgroundColor: themeVars.badge.brand.background.idle,
        color: themeVars.badge.foreground.default,
      },
    },
  },
]);
